export default "__VITE_ASSET__0Cjy_wCC__"